import { formatDisplayDateTime } from '@superbet-group/web.lib.vue-utilities';
import { computed } from '@vue/composition-api';

export function useEventFormattedDate(startDate: Date | undefined) {
    const formattedDate = computed(() => {
        if (!startDate) {
            return null;
        }
        return formatDisplayDateTime(startDate);
    });

    return {
        formattedDate,
    };
}
